@if (quoteData$ |async; as quoteData) {
  <div class="container container-style quote-container">
    <div class="quoteSection">
      <h1 class="rightQuote">
        <div class="quote-class">{{'common.text_quote_name'|cxTranslate}}</div>
        <div class="quote-id">ID:{{quoteCode}}</div>
      </h1>
      <div class="quote-count" [routerLink]="'/my-quotes'">{{translatedValue}}
      </div>
      <!-- quoteCount -->
    </div>
    <div class="row btn-bottom">
      <div class="col-12 col-sm-4 col-lg-3 mb-3 mb-sm-0  ">
        <button class="btn-blue continue-button"
        (click)="goBack()">{{'common.general_continue_shopping'|cxTranslate}}</button>
      </div>
      @if (quoteData.quoteState.code == 'BUYER_DRAFT') {
        <div class="col-12 col-sm-4 col-lg-3 offset-lg-3  mb-3 mb-sm-0 ">
          <button (click)="openDialogBox(false)"
          class="btn-blue  cancel-button">{{'common.text_account_quote_action_display_CANCEL'|cxTranslate}}</button>
        </div>
        <div class="col-12 col-sm-4 col-lg-3  mb-3 mb-sm-0  " (click)="openDialogBox(true)">
          <button class="btn submit-button">{{'common.quote_submit'|cxTranslate}}</button>
        </div>
      }
    </div>
    <form [formGroup]="quoteForm">
      <section>
        <div class=" row status-header">
          <div class=" col-sm-7 offset-sm-5 status-body">
            <div class="col-sm-4 status-body-left">
              <div class="">
                <span>{{'common.text_headline_status'|cxTranslate}} </span>
                <span> : Draft</span>
              </div>
            </div>
            <div class="col-sm-8 status-body-right">
              <div class="">
                <span>{{'common.text_quote_code'|cxTranslate}}</span>
                <span>{{quoteCode}}</span>
              </div>
              <div class="toggle-btn" (click)="this.toptoggle = !this.toptoggle;">
                <img class="icon-toggle-style" src="/icons/arrow_down-white.svg">
              </div>
            </div>
          </div>
        </div>
        @if (toptoggle) {
          <div [@conditionalTrigger]="toptoggle ? 'shown' : 'notshown'">
            <div class="status-input">
              <div class="row status-input-body">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 status-input-left">
                  <label for="name"
                  class="status-name">{{'common.text_account_addressBook_page_sort_byName'|cxTranslate}}</label>
                  <input id="name" formControlName="quoteName" type="text "
                    class="form-control form-custom" />
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-7 status-input-right">
                    <label for="description"
                      class="status-description">{{'common.text_generalInfo_description'|cxTranslate}}
                    {{'common.login_optional'|cxTranslate}}</label>
                    <input id="description" formControlName="description" type="text"
                      class="form-control form-custom" />
                      <div class="status-estimate">
                      {{'common.text_quote_previous_estimated_total_display'|cxTranslate}} 0.00 USD</div>
                    </div>
                  </div>
                </div>
                <div class=" row quote-header">
                  <div class="quote-body">
                    <div>
                      <img class="icon-toggle-style" (click)="this.bottomtoggle = !this.bottomtoggle;"
                        src="/icons/arrow_down-white.svg">
                        <span>{{'common.quote_level_comments'|cxTranslate}}</span>
                      </div>
                    </div>
                  </div>
                  @if (bottomtoggle) {
                    <div class="quote-input" [@conditionalTrigger]="bottomtoggle ? 'shown' : 'notshown'"
                      >
                      <div class="row quote-input-body">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                          <div class="quote-date">
                            {{quoteData?.updatedTime | date:'MMM d, y, h:mm a'}}
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-7 quote-input-right">
                          <label for="comment"
                            class="quote-comments">{{'common.text_account_orderApprovalDetails_comments_label'|cxTranslate}}
                          {{'common.login_optional'|cxTranslate}}</label>
                          <textarea formControlName="comment" id="comment" type="text"
                          class="form-control form-custom"></textarea>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <section>
                <div class="fs-bl-15 col-xs-12 col-lg-10 my-3 text-right">
                  {{quoteData.totalItems}} {{'common.basket_page_totals_total_items_one'|cxTranslate|slice:3:9}}
                  &nbsp;|&nbsp;{{quoteData?.totalPriceWithTax?.formattedValue}}&nbsp;{{quoteData?.totalPriceWithTax?.currencyIso}}
                </div>
              </section>
              @if (!isMobile) {
                <section class="mb-2">
                  <div class="blue-header">
                    <div class="img-section"></div>
                    <div class="item-section">{{'common.basket_page_item'|cxTranslate}}</div>
                    <div class="price-section">{{'common.basket_page_price'|cxTranslate}}</div>
                    <div class="qty-section">{{'common.product_detail_quantity'|cxTranslate}}</div>
                    <div class="close-section"></div>
                    <div class="total-section">{{'common.text_quickOrder_page_total'|cxTranslate}}</div>
                  </div>
                  @for (product of quoteData.entries; track product) {
                    <div class="prod-quote-body ">
                      <div class="img-section">
                            <a [attr.aria-label]="
                                !product.product.images?.hasOwnProperty('PRIMARY')
                                   ? ('productDetails.noProductImage'
                                     | cxTranslate: { product: product.product.name })
                                       : undefined
                                    " [routerLink]="product?.product?.url"
                          class="cx-product-image-container">
                          <cx-media class="cx-product-image"
                            [container]="product.images?.PRIMARY || product.product.images" format="product"
                          [alt]="product.product.name || product.product.summary"></cx-media>
                        </a>
                      </div>
                      <div class="item-section">
                        <a [routerLink]="product.product.url" class="cx-product-name">
                          <label class="label-style product-typeNumber">{{product.product.name}}</label>
                        </a>
                        <label class="pro-code" [innerHtml]="product.product.code"></label>
                      </div>
                      <div class="price-section">{{'common.basket_page_poa'|cxTranslate}}</div>
                      <div class="qty-section">{{product.quantity}}</div>
                      <div class="total-section"><b>{{'common.basket_page_poa'|cxTranslate}}</b></div>
                      <div class="close-section">
                        <img (click)="removeProduct(product.entryNumber)"
                          src="/icons/close-red.svg" [width]="17" alt="">
                        </div>
                      </div>
                    }
                  </section>
                }
                @if (isMobile) {
                  <div class="isMobile">
                    @for (product of quoteData.entries; track product) {
                      <hr>
                        <div class="mobile-body">
                          <div class="mobile-body-left">
                            <div class="mobile-body-left-img">
                                <a [attr.aria-label]="
                                !product.product.images?.hasOwnProperty('PRIMARY')
                                   ? ('productDetails.noProductImage'
                                     | cxTranslate: { product: product.product.name })
                                       : undefined
                                    " [routerLink]="product?.product?.url"
                                class="cx-product-image-container">
                                <cx-media class="cx-product-image"
                                  [container]="product.images?.PRIMARY || product.product.images" format="product"
                                [alt]="product.product.name || product.product.summary"></cx-media>
                              </a>
                            </div>
                            <div class="mobile-body-left-cont">
                              <div class="mobile-style">
                                <a [routerLink]="product.product.url" class="cx-product-name">
                                  <label class="label-style product-typeNumber">{{product.product.name}}</label>
                                </a>
                                <label class="mobile-pro-code" [innerHtml]="product.product.code"></label>
                              </div>
                              <div class="quote-priceRequest">{{'common.basket_page_poa'|cxTranslate}}:
                              {{product.quantity}}</div>
                              <div class="quote-priceRequest"><b>{{'common.basket_page_poa'|cxTranslate}}</b></div>
                            </div>
                          </div>
                          <div class="mobile-body-right">
                            <img (click)="removeProduct(product.entryNumber)"
                              src="/icons/close-red.svg" [width]="17" alt="">
                            </div>
                          </div>
                          <hr>
                          }
                        </div>
                      }
                      <div class="row footer-section">
                        <div class="d-none d-sm-none d-md-none d-lg-block col-lg-7"></div>
                        <div class="col-sm-12 col-md-12 col-lg-5 footer-style">
                          <div class="footer-sub">{{'common.basket_page_totals_subtotal'|cxTranslate}}</div>
                          <div class="footer-req footer-priceRequest">{{'common.basket_page_poa'|cxTranslate}}</div>
                        </div>
                      </div>
                    </section>
                  </form>
                </div>
              }